import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useDemo } from '../contexts/DemoContext';
import './DemoToggle.css';

const DemoToggle = () => {
  const { isAdmin } = useAuth();
  const { demoMode, setDemoMode } = useDemo();

  if (!isAdmin) return null;

  return (
    <div className="demo-toggle">
      <label className="demo-switch">
        <input type="checkbox" checked={demoMode} onChange={(e) => setDemoMode(e.target.checked)} />
        <span className="demo-slider" />
      </label>
      <span className="demo-label">{demoMode ? 'Demo Mode: ON' : 'Demo Mode: OFF'}</span>
    </div>
  );
};

export default DemoToggle;
